/**
 * @generated SignedSource<<1baead16a5f2169495378baba60ecab2>>
 * @relayHash 98138124c546a05166365da8d2f64fe7
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 98138124c546a05166365da8d2f64fe7

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      }
    ],
    "concreteType": "ElectronicSignatureState",
    "kind": "LinkedField",
    "name": "signatureState",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ElectronicSignatureQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ElectronicSignatureQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "98138124c546a05166365da8d2f64fe7",
    "metadata": {},
    "name": "ElectronicSignatureQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "94d6a1bd8b628a9f75fe5885d577fc64";

export default node;
